import { types } from './actions';

const initalState = {
  showHeader: true,
};

const reducer = (state = initalState, action) => {
  switch (action.type) {
    case types.SET_SHOW_HEADER: {
      const { showHeader } = action;
      // NOTE: always converts the value to a boolean
      const boolShowHeader = (showHeader === 'true');
      return {
        ...state,
        showHeader: boolShowHeader,
      };
    }

    default:
      return state;
  }
};

export default reducer;
